import Box from '@mui/material/Box';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock, MetaLine } from '../activityFeedHeaderShared';

function AssetAnalysisCompletedHeader({ entity, item, activity }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={item.assetName || 'Asset analysis'} activity={activity} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {entity.revision != null && <MetaLine>{`Revision ${entity.revision}`}</MetaLine>}
          <DescriptionSecondary item={item} />
        </Box>
      }
    />
  );
}

export default AssetAnalysisCompletedHeader;
